import { HttpClient, HttpEventType } from '@angular/common/http';
import { Injectable, Inject } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { catchError, filter, map, Observable, of, tap } from 'rxjs';
import { Environment } from '../classes/environment';
import { NewsCategory } from '../classes/news';


@Injectable({ providedIn: 'root' })
export class CategoryService {

	private categoryCache: NewsCategory[] = [];


	constructor(
		@Inject('environment') private environment: Environment,
		private httpClient: HttpClient,
		private matSnackBar: MatSnackBar,
	) {}

	


	loadCategories(): Observable<boolean> {

		return this.httpClient.get<NewsCategory[]>( this.environment.backendUrl + 'nachrichten/kategories' ).pipe(

			map( categories => {
				if( !categories || !categories.length ) return false;
				this.categoryCache = categories;
				return true;
			}),
			catchError( err => {
				this.matSnackBar.open( 'Beim Abrufen der Liste der Kategorien ist ein Fehler aufgetreten', 'Fehler' );
				return of(false);
			})

		);

	}

	getCategoriesInCache(): NewsCategory[] {
		return structuredClone( this.categoryCache );
	}

}


